<div class="invoices-container">
    <app-invoices-add (invoiceAdded)="handleInvoiceAdd($event)" [invoice]="invoice"></app-invoices-add>
    <app-invoices-list [reloadDataSubject]="reloadSubject.asObservable()"></app-invoices-list>
</div>
